export enum RsvpType {
	Sponsor = 1,
	Individual = 2,
	TargetGroup = 3
}



// WEBPACK FOOTER //
// ./src/app/models/rsvp-type.enum.ts